<template>
  <v-container fluid>
    <div class="main">

      <div class="text-end mb-3">
        <v-btn color="gifty"
               dark
               class="rounded-lg"
               depressed
               @click="addItem"
        >
          <v-icon left>mdi-plus</v-icon>
          Ajouter
        </v-btn>
      </div>

      <v-overlay :value="overlay" absolute color="white" opacity="0.5">
        <v-progress-circular
            color="primary"
            indeterminate
            size="50"
        ></v-progress-circular>
      </v-overlay>

      <v-row>
        <v-col cols="12">
          <v-card class="rounded-lg shadow">
            <v-card-title>
              <div>
                <v-text-field hide-details
                              v-model="keyword"
                              rounded
                              filled
                              dense
                              append-icon="mdi-magnify"
                              single-line
                              clearable
                              placeholder="Rechercher..."
                              v-on:keyup.enter="fetchData"
                />
              </div>
            </v-card-title>

            <v-divider/>

            <v-card-text class="pa-0">

              <div v-if="isLoading">
                <v-skeleton-loader type="table"></v-skeleton-loader>
              </div>

              <div v-else>
                <v-data-table :headers="headers"
                              :items="campaigns"
                              :search="keyword"
                >

                  <template v-slot:item.status="{ item }">
                    <v-switch v-model="item.is_active"
                              class="pa-0 ma-0"
                              color="success"
                              hide-details
                              readonly
                              @click="changeStatus(item.id)"></v-switch>

                  </template>


                  <template v-slot:item.start_date="{ item }">
                    <v-chip
                        :style="{ background: 'rgba(25,233,18,0.12)', color: '#19e912' }"
                    >
                      <v-icon left small color="success">mdi-calendar-start</v-icon>
                      {{ item.start_date }}
                    </v-chip>
                  </template>


                  <template v-slot:item.end_date="{ item }">
                    <v-chip
                        :style="{ background: 'rgba(233,18,18,0.12)', color: '#e91212' }"
                    >
                      <v-icon left small color="error">mdi-calendar-end</v-icon>
                      {{ item.end_date }}
                    </v-chip>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <div class="d-flex align-center">
                      <v-btn icon @click="updateItem(item)">
                        <v-icon>mdi-pencil-outline</v-icon>
                      </v-btn>
                      <v-btn icon @click="remove(item.id)">
                        <v-icon>mdi-delete-outline</v-icon>
                      </v-btn>
                    </div>
                  </template>

                </v-data-table>


              </div>

            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <AddDialog ref="addDialog" @refresh="fetchData"/>

    </div>
  </v-container>
</template>

<script>
import AddDialog from "./components/AddDialog.vue";
import {HTTP} from "@/http-common";

export default {
  components: {
    AddDialog,
  },
  data() {
    return {
      FILE_URL: process.env.VUE_APP_FILE_URL,
      isLoading: false,
      overlay: false,
      delete_id: null,
      keyword: null,
      headers: [
        {
          text: 'Status',
          align: 'start',
          sortable: false,
          value: 'status',
        },
        {
          text: 'Description',
          value: 'description',
        },
        {
          text: 'Début',
          value: 'start_date',
        },
        {
          text: 'Fin',
          value: 'end_date',
        },
        {
          text: 'Order',
          value: 'order',
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
        },
      ],
      campaigns: [],
    };
  },
  methods: {
    fetchData() {
      this.isLoading = true
      HTTP.get('/v1/spintowins').then(res => {
        this.campaigns = res.data.data
        this.isLoading = false
      }).catch(err => {
        this.isLoading = false
        console.log(err)
      })
    },
    addItem() {
      this.$refs.addDialog.open();
    },
    updateItem(item) {
      this.$refs.addDialog.edit(item);
    },
    openGifts(id) {
      this.$refs.giftsDialog.open(id);
    },
    remove(id) {
      this.delete_id = id;
      this.$confirm_dialog = true;
    },
    deleteItem() {
      this.overlay = true;
      HTTP.post("/v1/spintowins/delete", {
        id: this.delete_id,
      }).then(() => {
        this.overlay = false;
        let i = this.campaigns.findIndex((el) => el.id === this.delete_id);
        this.$delete(this.campaigns, i);
        this.delete_id = null;
        this.$successMessage = "Cet élément a été supprimé avec succès.";
      }).catch((err) => {
        this.overlay = false;
        console.log(err);
      });
    },
    changeStatus(id) {
      this.overlay = true;
      HTTP.post("/v1/spintowins/change-status", {
        id: id,
      }).then(() => {
        this.overlay = false;
        let index = this.campaigns.findIndex(el => el.id === id)
        this.campaigns[index].is_active = !this.campaigns[index].is_active
        this.$successMessage = "Cet élément a été modifié avec succès.";
      }).catch((err) => {
        this.overlay = false;
        console.log(err);
      });
    },
  },
  mounted() {
    this.fetchData();
  },
  watch: {
    $is_confirm: function (el) {
      if (el) {
        this.deleteItem();
        this.$is_confirm = false;
      }
    },
  },
}
</script>

<style>
</style>